export const DEFAULT_VIZ_ASPECT = '50 / 31'

function readCssNumberVar(name, fallback) {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
    const n = parseFloat(v)
    return Number.isFinite(n) ? n : fallback
  } catch {
    return fallback
  }
}

export function getChartFontSizes() {
  const title = readCssNumberVar('--chart-title-font-size', 24)
  const legend = readCssNumberVar('--chart-legend-font-size', 14)
  const axisTitle = readCssNumberVar('--chart-axis-title-font-size', 18)
  const tick = readCssNumberVar('--chart-tick-font-size', 16)
  return { title, legend, axisTitle, tick }
}

export function getDefaultChartOptions() {
  const f = getChartFontSizes()
  return {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 31 / 50,
    animation: false,
    plugins: {
      legend: { display: true, position: 'top', labels: { font: { size: f.legend } } },
      title: { display: false, font: { size: f.title } }
    },
    scales: {
      x: { title: { display: true, font: { size: f.axisTitle } }, ticks: { font: { size: f.tick } } },
      y: { title: { display: true, font: { size: f.axisTitle } }, ticks: { font: { size: f.tick } } }
    }
  }
}